// extracted by mini-css-extract-plugin
module.exports = {"templateInfo":"style-module--templateInfo--2MiKT","actions":"style-module--actions--2y2yB"};